import { ReactElement, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { DashboardScreen } from './dashboard-screen'
import AppNavigation from '../../components/app-navigation/app-navigation'
import { Flexbox } from '../../components/flexbox/flexbox'
import UsersScreen from './users-screen'
import AccountsScreen from './accounts-screen'
import DepositsScreen from './deposits-screen'
import InvestingCycleScreen from './investing-cycle-screen'
import ProfileScreen from './profile-screen'
import AccessRolesScreen from './access-roles-screen'
import UserDetailScreen from './user-detail'
import SecurityScreen from './security-screen'
import WithdrawalsScreen from './withdrawals-screen'
import TradeProfitsScreen from './trade-profits-screen'
import BankConnectScreen from './bank-connect-screen'
import UserAddScreen from './user-add-screen'
import CurrenciesScreen from './currencies-screen'
import AccountDetailScreen from './account-detail-screen'

const AuthorizedRoot = (): ReactElement => {
  return (
    <Flexbox flex={1}>
      <AppNavigation />
      <Flexbox flex={1} className="p-8">
        <Suspense>
          <Routes>
            <Route index element={<DashboardScreen />} />
            <Route path="dashboard" element={<DashboardScreen />} />
            <Route path="manager">
              <Route path="accounts">
                <Route index element={<AccountsScreen />} />
                <Route path=":accountId" element={<AccountDetailScreen />} />
                <Route path="*" element={<AccountsScreen />} />
              </Route>
              <Route path="deposits" element={<DepositsScreen />} />
              <Route path="withdrawals" element={<WithdrawalsScreen />} />
              <Route path="profits" element={<TradeProfitsScreen />} />
              <Route path="bank-connect" element={<BankConnectScreen />} />
            </Route>
            <Route path="admin">
              <Route path="access-roles" element={<AccessRolesScreen />} />
              <Route path="currencies" element={<CurrenciesScreen />} />
              <Route path="users">
                <Route index element={<UsersScreen />} />
                <Route path="add" element={<UserAddScreen />} />
                <Route path=":userId" element={<UserDetailScreen />} />
                <Route path="*" element={<UsersScreen />} />
              </Route>
            </Route>
            <Route path="settings">
              <Route path="profile" element={<ProfileScreen />} />
              <Route path="security" element={<SecurityScreen />} />
            </Route>
            <Route path="tools">
              <Route path="investing-cycle" element={<InvestingCycleScreen />} />
            </Route>
          </Routes>
        </Suspense>
      </Flexbox>
    </Flexbox>
  )
}

export default AuthorizedRoot